/**
 * src/components/ui/buttonVariants.ts
 * =============================================================================
 * Variants del botón base (cva). Archivo separado de Button.tsx por la regla
 * de lint `react-refresh/only-export-components`: un archivo con un componente
 * NO puede exportar también constantes, porque rompe el Fast Refresh de Vite.
 *
 * Si necesitamos las clases del botón en otro sitio (ej. <Link> estilado como
 * botón en la landing), importamos directamente desde aquí.
 * =============================================================================
 */

import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        outline:
          'border border-border bg-transparent hover:bg-accent hover:text-accent-foreground',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        danger: 'bg-destructive text-white hover:bg-destructive/90',
      },
      size: {
        sm: 'h-7 px-2.5 text-xs',
        md: 'h-9 px-4',
        lg: 'h-11 px-6 text-base',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)
